.ticket-price-single-selection .no-price-group {
  text-align: center;
  padding: 15px 10px 30px 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.ticket-price-single-selection .no-price-group .actions {
  margin-top: 10px;
}
.ticket-price-single-selection .btn.btn-price-group {
  padding: 0;
}
.ticket-price-single-selection .btn.btn-price-group:disabled > .price-group {
  justify-content: space-between;
}
.ticket-price-single-selection .btn.btn-price-group:disabled > .price-group .name, .ticket-price-single-selection .btn.btn-price-group:disabled > .price-group .price, .ticket-price-single-selection .btn.btn-price-group:disabled > .price-group .warnings > :not(.kind-error) {
  text-decoration: line-through 2px;
}
.ticket-price-single-selection .price-group {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px 15px;
}
.ticket-price-single-selection .price-group .info, .ticket-price-single-selection .price-group .ticket-selection-warning-list {
  display: flex;
}
.ticket-price-single-selection .price-group .info {
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
}
.ticket-price-single-selection .price-group .ticket-selection-warning-list {
  flex-direction: column;
  align-items: start;
  text-transform: none;
  font-size: 14px;
  font-weight: 400;
  text-align: left;
}
.ticket-price-single-selection .price-group .name {
  flex: 6;
  text-align: left;
  text-transform: none;
}
.ticket-price-single-selection .price-group .price {
  background-color: #fff;
  border-radius: 50px;
  padding: 2px 15px;
}
.ticket-price-single-selection .actions {
  display: flex;
  justify-content: center;
  padding-top: 10px;
}
.ticket-price-single-selection .actions > *:not(:first-child) {
  margin-left: 10px;
}
.ticket-price-single-selection .loading-panel {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 150px;
}

@media screen and (max-width: 800px) {
  .loading-panel {
    width: 100%;
  }
  .price-group {
    padding: 5px;
  }
  .price-group .info {
    flex-direction: column;
  }
  .price-group .price {
    background-color: #fff;
    border-radius: 50px;
    padding: 1px 7px;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */